import {
  LOGIN_FAILED,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  TEST_ACTION,
  TOGGLE_STRATEGY,
  USER_LOGGED_IN_FAILED,
  USER_LOGGED_IN_REQUEST,
  USER_LOGGED_IN_SUCCESS,
  VERIFY_TOKEN_FAILED,
  VERIFY_TOKEN_REQUEST,
  VERIFY_TOKEN_SUCCESS,
  SET_VALIDATION_ERROR,
  USER_SINGUP_SUCCESS,
  USER_SINGUP_FAILED,
  USER_SINGUP_REQUEST,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILED,
  VERIFY_USER_LOGIN_REQUEST,
  VERIFY_USER_LOGIN_SUCCESS,
  VERIFY_USER_LOGIN_FAILED,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  DISPLAY_PROFILE_REQUEST,
  DISPLAY_PROFILE_SUCCESS,
  DISPLAY_PROFILE_FAILED,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILED,
  USER_PHONE_VERIFY_REQUEST,
  USER_PHONE_VERIFY_SUCCESS,
  USER_PHONE_VERIFY_FAILED,
  USER_PASSWORD_RESET_REQUEST,
  USER_PASSWORD_RESET_SUCCESS,
  USER_PASSWORD_RESET_FAILED,
  // TOKEN_EXPIRY,
} from '../constants/actionTypes';
import data from '../data/data';

export const initialStore = {
  sample: false,
  strategyOpen: false,
  loggedIn: false,
  userData: {},
  validationError: {},
  sign_up_res: '',
  phoneOtp: '',
  userDetails: {},
  otp_res: '',
  login_res: '',
  first_login_in: true,
  update_prof_res: '',
  update_pass_res: '',
  forgot_password_res: '',
  verify_phone_res: '',
  userName: '',
  userState: '',
  userCity: '',
  // userCountry: '',
  userBrokerData: [],
  showUserProfRes:'',
  userGender:'',
  userEmail:'',
  userPhoneNo:'',
  loading: false,
  signupLoading: false,
  updateProfLoading: false,
  updatePassLoading: false,
  // user_auth_token: '',
  // tokenExpiry: true,
  // reason:'',
};

export default (state = initialStore, action) => {
  switch (action.type) {
    case TEST_ACTION:
      return {
        ...state,
        sample: !state.sample,
      };
    case TOGGLE_STRATEGY:
      return {
        ...state,
        strategyOpen: action.data,
      };
    case LOGOUT_USER:
      return {
        ...state,
        userData: {},
        loggedIn: false,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        loggedIn: false,
      };
    case USER_LOGGED_IN_REQUEST:
      return {
        ...state,
        loggedIn: false,
        userData: {},
      };
    case USER_LOGGED_IN_SUCCESS:
      return {
        ...state,
        loggedIn: action.data.logged_in,
        userData: action.data,
      };
    case USER_LOGGED_IN_FAILED:
      return {
        ...state,
        loggedIn: false,
        userData: {},
      };
    case VERIFY_TOKEN_REQUEST:
      return {
        ...state,
        loggedIn: false,
        userData: {},
      };
    case VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        userData: action.data,
      };
    case VERIFY_TOKEN_FAILED:
      return {
        ...state,
        loggedIn: false,
        userData: {},
      };
    case SET_VALIDATION_ERROR:
      return {
        ...state,
        validationError: { ...state.validationError, ...action.data },
      };


    case USER_SINGUP_REQUEST:
      return {
        ...state,
        signupLoading: true,
        error: false,
      };
    case USER_SINGUP_SUCCESS:
      return {
        ...state,
        signupLoading: false,
        sign_up_res: action.data.message,

      };
    case USER_SINGUP_FAILED:
      return {
        ...state,
        signupLoading: false,
        sign_up_res: action.error.response.data.message
      };
    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        phoneOtp: '',
        userDetails: {},
        error: false,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        phoneOtp: action.phoneOtp,
        otp_res: action.data.message,
        error: false,
      };
    case VERIFY_OTP_FAILED:
      return {
        ...state,
        phoneOtp: '',
        userDetails: {},
        error: true,
        otp_res: action.error.response.data.message,
      };

    case VERIFY_USER_LOGIN_REQUEST:
      return {
        ...state,
        error: false,
        loggedIn: true,
        loading:true,
      };
    case VERIFY_USER_LOGIN_SUCCESS:
      return {
        ...state,
        error: false,
        loggedIn: true,
        login_res: action.data.message,
        loading: false,
        first_login_in: action.data.first_login,
        // user_auth_token: action.data.auth_token
      };
    case VERIFY_USER_LOGIN_FAILED:
      return {
        ...state,
        error: true,
        loggedIn: false,
        loading: false,
        login_res: action.error?.response?.data?.message,
      };

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        error: false,
        updateProfLoading: true,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        error: false,
        update_prof_res: action.data.message,
        updateProfLoading: false,
      };
    case UPDATE_PROFILE_FAILED:
      return {
        ...state,
        error: true,
        update_prof_res: action.error.response.data.message,
        updateProfLoading: false,

      };
      // {"broker_data":{},"city":null,"country":null,"gender":null,"state":null,"username":null}
    case DISPLAY_PROFILE_REQUEST:
      return {
          ...state,
          error: false,
        };
    case DISPLAY_PROFILE_SUCCESS:
      console.log(action.data.broker_data,"action.data.broker_data")
      return {
          ...state,
          error: false,
          userName: action.data.username,
          userState: action.data.state,
          userCity: action.data.city,
          userCountry: action.data.country,
          userGender: action.data.gender,
          userBrokerData: action.data.broker_data,
          userEmail: action.data.email,
          userPhoneNo: action.data.phone,
        };
    case DISPLAY_PROFILE_FAILED:
      return {
          ...state,
          error: true,
          showUserProfRes:action.error.response
        };

    case UPDATE_PASSWORD_REQUEST:
       return {
          ...state,
          error: false,
          updatePassLoading: true,
        };
    case UPDATE_PASSWORD_SUCCESS:
        return {
          ...state,
          error: false,
          update_pass_res: action.data.message,
          updatePassLoading: false,
        };
    case UPDATE_PASSWORD_FAILED:
        return {
          ...state,
          error: true,
          update_pass_res: action.error.response.data.message,
          updatePassLoading: false,
        };
    case USER_PHONE_VERIFY_SUCCESS:
      return {
        ...state,
        signupLoading: false,
        verify_phone_res: action.data.message,

      };
    case USER_PHONE_VERIFY_FAILED:
      return {
        ...state,
        signupLoading: false,
        verify_phone_res: action.error.response ? action.error.response.data.message : "User not exists with this phone number!"
      };
    case USER_PASSWORD_RESET_SUCCESS:
            return {
              ...state,
              error: false,
              forgot_password_res: action.data.message,
              updatePassLoading: false,
            };
        case USER_PASSWORD_RESET_FAILED:
            return {
              ...state,
              error: true,
              forgot_password_res: action.error.response ? action.error.response.data.message : "Failed to reset the password",
              updatePassLoading: false,
            };

    // case TOKEN_EXPIRY:
    //   // console.log(tokenExpiry,"tokenExpiry in action")
    //   return {
    //     ...state,
    //     tokenExpiry: true,
    //     reason: action.reason,
    //   };


    default:
      return state;
  }
};
